(() => {
    let header = document.querySelector('.js-header');
	let banner = document.querySelector('.js-banner');

	if(header && banner){
		banner.style.marginTop = header.offsetHeight + "px";
		window.addEventListener('resize', e => {
			banner.style.marginTop = header.offsetHeight + "px";
		});
	}
})();